import { navigateToAjs } from './navigator';
import { UPGRADED_ROUTES } from '../config';
import { environment } from '../../environments/environment';
import { resolveUrl } from "@app/core/resolve-url";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { NgZone } from "@angular/core";
import { CanDeactivateGuard } from "@app/services";
var pathToNav;
var apiHost = environment.apiHost;
var HybridFactory = /** @class */ (function () {
    function HybridFactory() {
    }
    HybridFactory.getEnvironment = function () {
        return JSON.parse(JSON.stringify(environment));
    };
    HybridFactory.isUpgraded = function (url) {
        var presentInUpgradedList = UPGRADED_ROUTES.find(function (pathPattern) {
            return (new RegExp(pathPattern, 'g')).test(url);
        });
        return !!presentInUpgradedList;
    };
    // Get AngularJs state from url
    HybridFactory.getState = function ($state, url, queryParams) {
        var match = $state.get().find(function (state) {
            if (!state.name || state.abstract || !state.$$state)
                return false;
            var privatePortion = state.$$state();
            if (!privatePortion.url)
                return false;
            return privatePortion.url.exec(url, queryParams);
        });
        return match ? { state: match, params: match.$$state().url.exec(url, queryParams) } : null;
    };
    HybridFactory.redirectMicroFrontendRoute = function (path) {
        var redirectEvent = new CustomEvent('navigate-in-element', {
            detail: { path: path }
        });
        dispatchEvent(redirectEvent);
    };
    HybridFactory.redirectNg7Route = function (route) {
        var router = HybridFactory.ngUpgrade.injector.get(Router), location = HybridFactory.ngUpgrade.injector.get(Location), $state = HybridFactory.ngUpgrade.$injector.get('$state'), ngZone = HybridFactory.ngUpgrade.injector.get(NgZone);
        var url = resolveUrl(route), path = location.normalize(url.pathname);
        ngZone.run(function () {
            $state.go('loggedin.empty');
            HybridFactory.routeContainerCleanedUp = true;
            router.navigateByUrl(path + url.search + url.hash);
        });
    };
    // AngularJs location change start hook
    HybridFactory.onLocationChangeStart = function (event, next, full) {
        var router = HybridFactory.ngUpgrade.injector.get(Router), location = HybridFactory.ngUpgrade.injector.get(Location), ngZone = HybridFactory.ngUpgrade.injector.get(NgZone), $state = HybridFactory.ngUpgrade.$injector.get('$state');
        var url = resolveUrl(next), path = location.normalize(url.pathname), isUpgraded = HybridFactory.isUpgraded(decodeURIComponent(path));
        var $rootScope = HybridFactory.ngUpgrade.$injector.get('$rootScope');
        // console.log('onLocationChangeStart', $rootScope.csNewUiVersion, path);
        var redirectUrl = HybridFactory.shouldRedirect(path, $rootScope.csNewUiVersion);
        if (redirectUrl) {
            event.preventDefault();
            if (redirectUrl.startsWith('loggedin')) {
                $state.go(redirectUrl);
            }
            else {
                ngZone.run(function () { return router.navigateByUrl(redirectUrl); }).then(function (r) { return r; });
            }
            return;
        }
        // This is if we get this from statechange for switching to a new/old UI views
        if (HybridFactory.urlSwitchedDueToVersion) {
            HybridFactory.urlSwitchedDueToVersion = false;
            event.preventDefault();
            pathToNav = resolveUrl(full).pathname;
            HybridFactory.transitState = {
                name: $state.current.name,
                url: $state.href($state.current.name)
            };
            $state.go('loggedin.empty');
            return;
        }
        // if ('clientsconfig' in event.targetScope.accessDetails &&
        //     'NewPropertyView' in event.targetScope.accessDetails.clientsconfig) {
        var regex = new RegExp("^/customers/(customer|customer_list|work_address)/(\\d+)/view/property/view");
        if (regex.test(path)) {
            var groupings_1 = regex.exec(path);
            ngZone.run(function () { return router.navigateByUrl('/customers/' + groupings_1[1] + '/' + groupings_1[2] + '/view_v2/property/view'); });
            HybridFactory.urlSwitchedDueToVersion = true;
            event.preventDefault();
            return;
        }
        // }
        if ('clientsconfig' in event.targetScope.accessDetails && 'NewJobView' in event.targetScope.accessDetails.clientsconfig) {
            // Do NOT redirect jobs_v2/.../costs/view -> parts/view here; allow direct navigation to costs view
            // (refresh, or clicking "Costs" tab). Redirect to parts only when coming from PO save - see onStateChangeStart.
            var regex1 = new RegExp('^/customers/(customer|customer_list|work_address)/(\\d+)/(jobs|job)/(\\d+)/(details|certificates|notes|reminders|files|invoices|costs|additional_works|invoice_items)/(view|jobcostsview)');
            var regex2 = new RegExp('^/customers/(customer|customer_list|work_address)/(\\d+)/(jobs|job)/(\\d+)/(view_parts|office_task|opportunities)');
            var groupings = regex1.exec(path) || regex2.exec(path);
            var jobLinkMap = {
                details: '/details/view',
                office_task: '/details/view',
                view_parts: '/parts/view',
                certificates: '/certificates/view',
                notes: '/details/view',
                reminders: '/details/view',
                files: '/files/view',
                invoices: '/invoices/view',
                costs: '/costs/view',
                additional_works: '/opportunities/view',
                invoice_items: '/costs/view',
                opportunities: '/opportunities/view'
            };
            if (event.targetScope.accessDetails.clientsconfig.NewJobView == 1 && groupings && groupings[5] && jobLinkMap[groupings[5]]) {
                // Old URL .../jobs/.../costs/jobcostsview -> redirect to jobs_v2/.../parts/view (not costs/view)
                var pathSegment = (groupings[5] === 'costs' || groupings[5] === 'invoice_items') ? '/parts/view' : jobLinkMap[groupings[5]];
                var newJobUrl_1 = "/customers/" + groupings[1] + "/" + groupings[2] + "/jobs_v2/" + groupings[4] + pathSegment;
                ngZone.run(function () { return router.navigateByUrl(newJobUrl_1); });
                HybridFactory.urlSwitchedDueToVersion = true;
                event.preventDefault();
                return;
            }
        }
        var pathName = window.location.pathname;
        localStorage.setItem('redirectTo', pathName);
        if ((next == apiHost + "/system_settings" || next == apiHost + "/company_settings" || next.includes('_settings#'))) {
            var pathName_1 = window.location.pathname;
            if (pathName_1.includes('purchase_trackers')) {
                pathName_1 = '/company_settings/purchase_trackers';
            }
            if (localStorage.getItem('redirectTo') != "/settings" && localStorage.getItem('redirectTo') != "") {
                localStorage.setItem('redirectTo', pathName_1);
            }
            navigateToAjs('/settings?prevSetting=' + pathName_1);
        }
        else {
            if (next.includes('settings#')) {
                var pathName_2 = window.location.pathname;
                //console.log("<--->"+pathName);
                navigateToAjs('/settings?prevSetting=' + pathName_2);
                if (localStorage.getItem('redirectTo') != "/settings" && localStorage.getItem('redirectTo') != "") {
                    localStorage.setItem('redirectTo', pathName_2);
                }
                //router.navigateByUrl('/settings?prevSetting=' + pathName);
                event.preventDefault();
                //return;
            }
        }
        if (HybridFactory.popstate || (isUpgraded && HybridFactory.routeContainerCleanedUp)) {
            event.preventDefault();
        }
        // Preventing repeated navigation on, ng2 to ng redirection
        else if (!HybridFactory.popstate && !isUpgraded && pathToNav == path && $state.current.name !== 'loggedin.empty') {
            event.preventDefault();
        }
        // Preventing navigation for the unsaved changes warning confirmation in any angular7 component
        HybridFactory.checkForNavigationConfirmation(event, url.pathname + url.hash);
        pathToNav = path;
        // Avoid AngularJs navigation for AngularES routes
        if (!event.defaultPrevented) {
            ngZone.run(function () { return router.navigateByUrl(path + url.search + url.hash); });
        }
        // Handle popstate events
        else if (HybridFactory.popstate) {
            var popstateIsUpgraded = HybridFactory.isUpgraded(HybridFactory.popstate), popstate = resolveUrl(HybridFactory.popstate);
            pathToNav = popstate.pathname;
            // Fill up the AngularJs ui-view, While getting back to the ng-ng2 transition state
            if (!popstateIsUpgraded
                && $state.current.name == "loggedin.empty"
                && HybridFactory.transitState) {
                var toState = HybridFactory.getState($state, HybridFactory.transitState.url == popstate.pathname ? HybridFactory.transitState.url : popstate.pathname, {});
                if (toState)
                    $state.go(toState.state.name, toState.params);
                HybridFactory.routeContainerCleanedUp = false;
                HybridFactory.transitState = null;
            }
            // Transit AngularJs state with respect to the location
            else if (!popstateIsUpgraded && $state.current.name !== "loggedin.empty") {
                var matchedState = HybridFactory.getState($state, popstate.pathname, {});
                if (matchedState)
                    $state.go(matchedState.state.name, matchedState.params);
            }
            // Clean up AngularJs ui-view, While ng-ng2 popstate transition
            else if (!HybridFactory.routeContainerCleanedUp && popstateIsUpgraded) {
                HybridFactory.transitState = {
                    name: $state.current.name,
                    url: $state.href($state.current.name)
                };
                $state.go('loggedin.empty');
                HybridFactory.routeContainerCleanedUp = true;
            }
        }
        HybridFactory.popstate = null;
    };
    HybridFactory.onStateChangeStart = function (event, toRoute, toParams, fromRoute, fromParams) {
        var router = HybridFactory.ngUpgrade.injector.get(Router), location = HybridFactory.ngUpgrade.injector.get(Location), ngZone = HybridFactory.ngUpgrade.injector.get(NgZone), $state = HybridFactory.ngUpgrade.$injector.get('$state');
        // if ('clientsconfig' in event.targetScope.accessDetails &&
        //     'NewPropertyView' in event.targetScope.accessDetails.clientsconfig) {
        if (toRoute.name == 'loggedin.customer_list.view.property') {
            ngZone.run(function () { return router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/view_v2/property/view'); });
            HybridFactory.urlSwitchedDueToVersion = true;
            event.preventDefault();
            return;
        }
        // }
        if ('clientsconfig' in event.targetScope.accessDetails && 'NewJobView' in event.targetScope.accessDetails.clientsconfig) {
            if (event.targetScope.accessDetails.clientsconfig.NewJobView == 1 && (toRoute.name == 'loggedin.customer_list.view.job.details' || toRoute.name == 'loggedin.customer_list.view.job.invoices' || toRoute.name == 'loggedin.customer_list.view.job.viewcost')) {
                if (toRoute.name == 'loggedin.customer_list.view.job.invoices') {
                    ngZone.run(function () { return router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/invoices/view'); });
                }
                else if (toRoute.name == 'loggedin.customer_list.view.job.viewcost') {
                    if (event.targetScope.accessDetails.clientsconfig.NewJobViewScreen == 'Invoices') {
                        ngZone.run(function () { return router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/invoices/view'); });
                    }
                    else {
                        // After PO save: parts PO -> parts/view; cost PO or view PO -> costs/view; default -> costs/view
                        var fromPartsPoState = fromRoute && fromRoute.name && (fromRoute.name.indexOf('new_job_part_purchase_order') !== -1 ||
                            fromRoute.name.indexOf('view_purchase_order') !== -1);
                        var viewPath_1 = fromPartsPoState ? '/parts/view' : '/costs/view';
                        ngZone.run(function () { return router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + viewPath_1); });
                    }
                }
                else {
                    ngZone.run(function () { return router.navigateByUrl('/customers/' + toParams['type'] + '/' + toParams['id'] + '/jobs_v2/' + toParams['jobId'] + '/details/view'); });
                }
                HybridFactory.urlSwitchedDueToVersion = true;
                event.preventDefault();
                return;
            }
        }
        HybridFactory.checkForNavigationConfirmation(event, toRoute.url);
    };
    // AngularJs location change success hook
    HybridFactory.onLocationChangeSuccess = function (event, caller, rootScope) {
        var $state = HybridFactory.ngUpgrade.$injector.get('$state'), settingsService = HybridFactory.ngUpgrade.$injector.get('NgSettingsService'), isUpgraded = HybridFactory.isUpgraded(decodeURIComponent(pathToNav));
        var $rootScope = HybridFactory.ngUpgrade.$injector.get('$rootScope');
        /*new change start - screen overlap issue */
        /*new change start - screen overlap issue */
        var subscription = HybridFactory.ngUpgrade.ngZone.onMicrotaskEmpty.subscribe(function () {
            if ($rootScope.$$phase && ($rootScope.$$phase === "$apply" || $rootScope.$$phase === "$digest")) {
                $rootScope.$$phase = null;
                //console.trace('My-trace');
                return $rootScope.$evalAsync();
            }
            // return $rootScope.$digest();
        });
        $rootScope.$on('$destroy', function () { subscription.unsubscribe(); });
        /*new change end*/
        if (isUpgraded && (caller == 'NG2'
            || $state.current.name == "" // This is to prevent show mobile device warning on page refresh
        )) {
            // Route back to AngularJS pages if its bookmarked
            if (!HybridFactory.routeContainerCleanedUp) {
                HybridFactory.transitState = {
                    name: $state.current.name,
                    url: $state.href($state.current.name)
                };
                $state.go('loggedin.empty');
            }
            else {
                // Update active tab for angularES navigation
                if (event.url && rootScope) {
                    var tabValue = event.url.split('/');
                    if (tabValue[1] != null && tabValue[1] != '') {
                        rootScope.selectedTab = tabValue[1];
                    }
                }
            }
            HybridFactory.routeContainerCleanedUp = true;
        }
        else
            HybridFactory.routeContainerCleanedUp = false;
    };
    // AngularJs state change success hook
    HybridFactory.onStateChangeSuccess = function (toRoute, toParams, fromRoute, fromParams) {
        HybridFactory.previousState = {
            name: fromRoute.name,
            url: fromRoute.url,
            params: fromParams
        };
    };
    HybridFactory.checkForNavigationConfirmation = function (event, url) {
        if (!event.defaultPrevented && CanDeactivateGuard.confirmationCallback) {
            CanDeactivateGuard.invoke(url);
            if (!CanDeactivateGuard.invokeResult)
                event.preventDefault();
        }
    };
    // ***************************************************************************
    HybridFactory.shouldRedirect = function (currentUrl, newUi) {
        var normalize = function (url) { return url.replace(/\/+$/, ""); };
        var cleanUrl = normalize(currentUrl);
        var a = [
            '/reporting_dashboard',
            '/reporting',
        ];
        // allow new Nav or old Nav
        var b = [
            '/reporting/operational/reporting_operational_list_parts/parts/requested',
            '/reporting/operational/reporting_operational_list_parts/parts/on_order',
            '/reporting/operational/reporting_operational_list_parts/parts/available',
            '/reporting/operational/stock_control/returns_operational_list/excess_for_job',
            '/reporting/operational/stock_control/returns_operational_list/stock_location',
            '/reporting/operational/stock_control/returns_operational_list/supplier',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/requested',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/on_order',
            '/reporting/operational/reporting_operational_list_parts/incomplete_part_completed_closed_jobs/available',
            '/reporting/view/users/time_sheets/viewSummary',
            '/reporting/view/users/timesheet_approval',
            '/reporting/view/users/daily_timecard',
            '/reporting/view/users/user_list',
            '/reporting/view/users/office_tasks',
            '/reporting/view/users/summary_timesheet/viewSummary',
            '/reporting/view/users/driver_detail'
        ];
        var c = ['/reporting_dashboard_v2'];
        if (!newUi) {
            var isV2 = c.some(function (path) { return cleanUrl.startsWith(path); });
            return isV2 ? 'loggedin.reporting.dashboard' : '';
        }
        var inA = a.some(function (path) {
            return new RegExp("^" + path + "(\\/|$)").test(cleanUrl);
        });
        var inB = b.some(function (path) { return cleanUrl.startsWith(path); });
        return inA && !inB ? '/reporting_dashboard_v2' : '';
    };
    HybridFactory.showUserPreferenceToggle = function (betaPropertyName, screenName, allowPath, additionalParams) {
        if (allowPath === void 0) { allowPath = ''; }
        if (additionalParams === void 0) { additionalParams = {}; }
        if (allowPath === undefined) {
            allowPath = '';
        }
        if (!additionalParams) {
            additionalParams = {};
        }
        var defaultTitle = 'Ready to explore the beta view?';
        var params = {
            NewTopNavUI: {
                title: defaultTitle,
                oldUrl: '/reporting_dashboard',
                newUrl: '/reporting_dashboard_v2/dashboard/default',
            },
            NewJobView: {
                title: defaultTitle,
                oldUrl: additionalParams['oldUrl'],
                newUrl: additionalParams['newUrl'],
            }
        };
        var settingsService = HybridFactory.ngUpgrade.$injector.get('NgSettingsService');
        var toggleService = HybridFactory.ngUpgrade.$injector.get('NgToggleuserpreferenceService');
        var path = window.location.pathname;
        function hideToggle() {
            toggleService.emit({
                showToggleSwitch: false
            });
        }
        // ---- Route validation ----
        // Only check allowPath restriction for NewTopNavUI screen
        if (screenName === 'NewTopNavUI') {
            if (!allowPath || path.indexOf(allowPath) !== 0) {
                console.log('Hide beta toggle switch');
                hideToggle();
                return;
            }
        }
        // Check if current path matches the NewJobView URL pattern
        // allowPath should contain the regex pattern as a string
        if (screenName === 'NewJobView') {
            var jobViewPattern = new RegExp(allowPath);
            if (!allowPath || !jobViewPattern.test(path)) {
                console.log('Hide beta toggle switch - not on new job view page');
                hideToggle();
                return;
            }
        }
        // ---- Beta validation ----
        var hubSpotBetaStatus = settingsService.getHubSpotBetaStatus();
        if (!hubSpotBetaStatus || !hubSpotBetaStatus[betaPropertyName]) {
            hideToggle();
            return;
        }
        var clientUserPreferences = settingsService.getClientUserPreferences();
        if (!clientUserPreferences) {
            hideToggle();
            return;
        }
        var preferenceValue = false;
        if (clientUserPreferences.hasOwnProperty(screenName)) {
            preferenceValue = !!clientUserPreferences[screenName];
        }
        var screenParams = params[screenName] || {};
        console.log('Show beta toggle switch');
        toggleService.emit({
            betaPropertyName: betaPropertyName,
            showToggleSwitch: true,
            integrationsUI: preferenceValue,
            preferenceValue: preferenceValue,
            screenName: screenName,
            labelName: screenParams.title || defaultTitle,
            oldUrl: screenParams.oldUrl,
            newUrl: screenParams.newUrl,
            dragEnabled: true
        });
    };
    HybridFactory.navigate = navigateToAjs;
    HybridFactory.routeContainerCleanedUp = false;
    HybridFactory.urlSwitchedDueToVersion = false;
    return HybridFactory;
}());
export { HybridFactory };
